export default __webpack_public_path__ + "static/GT-America-Standard-Regular-ab1beb742db41c5ca4d0f8f4fb8ba5b4.woff";